  
 export const handleSubscribeFun = (id, couponCode, send_email = false, isPopup = false) => {
    //获取国家code  并判断是否使用欧洲url
    const pattern = /^([a-zA-Z0-9-]+)\.([a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+)$/;
    const match = window.location.hostname.match(pattern);
    const countryCode = match[1] ? match[1] : 'global';
    const baseUrl = "https://shopify.roborock.com/api";
  
    let $input = $("#" + id + " .ro-subscribe__form-input input");
    let $button = $("#" + id + " .ro-subscribe__submit");
    let $tipText = $("#" + id + " .ro-subscribe__des");
    let $succcessText = $("#" + id + " .ro-subscribe__sucess-text");
    let $code = $("#" + id + " .ro-subscribe_code");
    let $toast = $("#" + id + " .ro-subscribe__toast");
  
    let stateCode = 0; //状态码 0--未提交  1--可复制
    const isCoupon = $("#" + id + " .ro-subscribe-main").data("is-coupon"); //是否折扣订阅

    //弹窗
    const $dialog = $("#" + id + " .ro-subscribe-popup");
  
    //按钮内容对应禁用状态
    let disabledObj = {
      "submit":false,
      "loading":true,
      "success":true,
      "copy":false,
    };
    
    //复制优惠编码
    async function handleCopy() {
      // 获取文本内容
      $toast.find(".ro-subscribe__toast-text").css("display","none");
      try {
        await navigator.clipboard.writeText(couponCode);
        $toast.find("#copy_success").css("display","inline");
      } catch (err) {
        $toast.find("#copy_failed").css("display","inline");
      }
      $toast.addClass("show");

      //展示1s后消失 
      setTimeout(() => {
        $toast.removeClass("show");
      }, 3000);
    }

    //成功文案状态操作
    function handeleSuccessText(id){
      //赋值优惠码
      couponCode && $code.text(couponCode);
      
      //处理提交成功为文案
      $input.removeClass("ro-subscribe__show");
      $succcessText.filter("#" + id).addClass("ro-subscribe__show");

      const $successMessage = $("#" + id + " .ro-subscribe__sucess-text");
      $successMessage.attr('aria-hidden', 'false');
      $successMessage.focus();
      
      //优惠弹窗，处理tip文案显示
      isCoupon && $tipText.find("p").each(function(index){
        let $this = $(this);
        index === 0 ? $this.removeClass("ro-subscribe__show") : $this.addClass("ro-subscribe__tip-up ro-subscribe__show");
         $this.attr('aria-hidden', index === 0 ?  'true': 'false');
      });
    }

    //复制文案状态操作
    function handeleCopyText(){

      //如果不是popup：false 则在input区展示优惠码, 如果是popup：true，则在按钮区展示优惠码
      !isPopup && (
            $succcessText.removeClass("ro-subscribe__show"),
            $code.addClass("ro-subscribe__show")
          );

       // 无障碍添加
        $button.attr('aria-live', 'polite');
        $button.attr('role', 'button');
        $button.focus();
      
      //更改提交状态码  复制按钮样式
      stateCode = 1;
      $button.addClass("ro-subscribe-copy");
    }
  
    //操作内容显示
    function handleContentShow(type) {
      //按钮内容展示
      $button.find(".ro-subscribe__btn").each(function(){
        let $this = $(this);
        let id = $(this).prop("id");
        
        if(id === type || (id == 'success' && type == 'repetition')){
          type == 'copy' ? (
            $this.css("position", "relative"),
            setTimeout(()=>{
              $this.addClass("ro-subscribe__show");
            },300)
          ) : $this.addClass("ro-subscribe__show");

          //修改按钮label 文案，保证无障碍
          let btnLabel = $(this).data("btn-label");
          $button.attr("aria-label", btnLabel);
          return;
        }
        
        $this.removeClass("ro-subscribe__show");
        $button.blur();
      })

      //按钮是否禁用
      $button.prop("disabled", disabledObj[type]);

      //input区只读
      $input.prop("readonly", type == 'submit' ? false : true );
      $input.attr("aria-hidden", type == 'submit' ? false : true );
      $input.attr("tabindex", type == 'submit' ? 0 :-1 );
      if(!isPopup)
        type == 'submit' ? 
            $("#" + id + " .ro-subscribe__form-input").removeClass("subscribe-read-only") 
            : 
            $("#" + id + " .ro-subscribe__form-input").addClass("subscribe-read-only");

      switch(type){
        case "loading":
          const $successMessage = $("#" + id + " #loading");
          $successMessage.attr('aria-live', 'polite');
          $successMessage.attr('role', 'status');
          $successMessage.focus();
          return;
        case "success":
          handeleSuccessText(type + 'Text');
          return;
        case 'repetition':
          handeleSuccessText(type + 'Text');
          return;
        case "copy":
          handeleCopyText();
          return ;
      }
    }

    // 优惠券添加
    function addCouponCode() {
        let xhr = new XMLHttpRequest()
        xhr.open('GET', '/discount/' + couponCode, true);
        xhr.send();
    }

    //请求Require
    async function handleReq(url, body){
      let res = await axios({
          method: 'post',
          url: baseUrl + url,
          data:body,
          headers: {
              'Content-Type': 'application/json',
              'X-Country':countryCode,
          }
      })
      return res.data;
    }
  
    //表单提交
    async function handleSubmit() {
      let { result, data, msg } = await handleReq("/common/subscribe/email", {
        email: $input.val(),
        send_email: JSON.parse(send_email.toLowerCase()),
      });
      if (result === 1) {
        //订阅成功
        handleContentShow("success");
        localStorage.setItem('isSubscribe', true);

        if(!isCoupon || !couponCode) return;

        //优惠弹窗，1s后展示优惠券
        addCouponCode();
        setTimeout(() => {
          handleContentShow("copy");
        }, 1000);
        
        return;
      }

      if(result === 1006){
        handleContentShow("repetition");
        return;
      }
      
      //失败，回到未提交状态
      handleContentShow("submit");
      
      // 添加错误提示
      $toast.find(".ro-subscribe__toast-text").css("display","none");
      $toast.find("#failed").css("display","inline");
      $toast.addClass("show");

      //展示3s后消失 
      setTimeout(() => {
        $toast.removeClass("show");
      }, 3000);
    }
    //提交表单
    $("#" + id + " #subscribeForm").on("submit", async function () {
      event.preventDefault(); // 阻止默认的提交行为
      if (stateCode === 1) {
        handleCopy();
        return;
      }
      handleContentShow("loading");
      await handleSubmit();
      
    });
  
    //错误判断
    function handleError() {
      let RegExp = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      let inputVal = $input.val();
      let state = RegExp.test(inputVal);
      if (!state) {
        $("#" + id + " .ro-subscribe__error").show();
        $button.prop("disabled", true);
        return;
      }
      $("#" + id + " .ro-subscribe__error").hide();
      $button.prop("disabled", false);
    }
  
    //输入，判断邮箱
    $input.on("input", function () {
      handleError();
    });


    //点击关闭按钮事件
    $("#" + id + " .ro-subscribe-close").on("click",function(){
      $dialog.get(0).close();
      // 让 body 可以被聚焦
      document.body.setAttribute('tabindex', '-1');
      
      // 设置焦点到 body
      document.body.focus();
    
      //更新弹窗打开时间  过期时间,24h 单位ms
      setWithExpiry("subscribePopupTime", "popupModel", 24 * 60 * 60 * 1000);
    });

    //设置过期时间
    function setWithExpiry(key, value, ttl) {
      const now = new Date()

      //保存对象，包括过期时间，单位毫秒
      const item = {
        value: value,
        expiry: now.getTime() + ttl,
      }
      localStorage.setItem(key, JSON.stringify(item))
    }

    //获取过期时间
    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      
      // key不存在，返回null
      if (!itemStr ) {
        return null
      }

      const item = JSON.parse(itemStr)
      const now = new Date()

      // 对比现在时间是否超过过期时间
      if (now.getTime() > item.expiry) {
        // 如果过期，移除时间
        localStorage.removeItem(key)
        return null
      }

      return item.value
    }
      
    function setTipHeight() {
      let max = 0;
      $tipText.find("p:visible").each(function () {
        let height = $(this).height();
        height > max && (max = height);
      });
      $tipText.css("height", max);
    }

    function setMeta(){
      var viewport = $('meta[name="viewport"]');
      if(viewport.length == 0) {
        $('head').append('<meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no">');
        return;
      }
      var content = viewport.attr('content');
      if(viewport.length > 0 && content.indexOf('user-scalable') == -1) {
        viewport.attr('content', content + ',user-scalable=no');
      };
    }

    //打开dialog弹窗,计算弹窗高度
    function openDialog() {
      $dialog.get(0).showModal();
      isCoupon && setTipHeight();
      let $content = $dialog.find(".ro-subscribe__content");
      let $textH = $dialog.find(".ro-subscribe__text").outerHeight(true);
      let $formH = $dialog.find(".ro-subscribe__form").outerHeight(true);
      let height = $textH + $formH + parseInt($content.css("padding-top"), 10) * 2;
      $dialog.height(height);
    }
  
    //首次加载 设置高度
    function handleInit() {
      // setMeta();
      
      const isSubscribe = JSON.parse(localStorage.getItem("isSubscribe"));
      isCoupon && setTipHeight();
      if(isPopup && getWithExpiry('subscribePopupTime') != 'popupModel' && !isSubscribe){
        openDialog();
      } 
    }
  
    handleInit();

    //兼容新品页订阅按钮点击事件
    if(isPopup)
      $('[id$="_subscription_b"]').on('click', function(){
        openDialog();
      });

   // 使用防抖封装处理函数
    let timer;
    const debouncedResize = ()=>{
      clearTimeout(timer);
      timer = setTimeout(()=>{
        isCoupon && setTipHeight();
      }, 100)
    };
  
    // 绑定 resize 事件
    $(window).on('resize', debouncedResize);
  }



